import { connect } from "react-redux";
import WelcomeComponent from "../Components/WelcomeComponent";


const mapDispatchToProps = (dispatch) => ({
 
});

export default connect(null, mapDispatchToProps)(WelcomeComponent);
